export enum StoreSelection {
  ALL_STORES = "ALL_STORES",
  CURRENT_STORE = "CURRENT_STORE",
  SPECIFIC_STORES = "SPECIFIC_STORES",
}
